import { render, staticRenderFns } from "./sidebar-dc.vue?vue&type=template&id=fd2af812&"
import script from "./sidebar-dc.vue?vue&type=script&lang=js&"
export * from "./sidebar-dc.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-dc.vue?vue&type=style&index=0&id=fd2af812&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports